import { ArrowsClockwiseIcon, BankIcon, CreditCardIcon, GiftIcon, StorefrontIcon } from '@phosphor-icons/react'

import { requestSummaryPreviewSections } from '../constants'

const titleKeys = {
  instantRefund: 'Reembolso instantáneo',
  refund: 'Reembolso',
  instantExchange: 'Cambio instantáneo',
  exchange: 'Cambio',
}

const methodNameKeys = {
  bankTransfer: 'Transferencia bancaria instantánea',
  originalPaymentMethod: 'Método de pago original',
  giftCard: 'Tarjeta regalo',
  storeCredit: 'Crédito en tienda',
}

export const copiesKeyMap = {
  'summary.instant_refund.bank_transfer': 'instantRefundBankTransfer',
  'summary.instant_refund.original_payment_method': 'instantRefundOriginalPaymentMethod',
  'summary.instant_refund.gift_card': 'instantRefundGiftCard',
  'summary.instant_refund.store_credit': 'instantRefundStoreCredit',
  'summary.refund.original_payment_method': 'refundOriginalPaymentMethod',
  'summary.refund.gift_card': 'refundGiftCard',
  'summary.refund.store_credit': 'refundStoreCredit',
  'summary.instant_exchange': 'instantExchange',
  'summary.exchange': 'exchange',
}

export const previewConfig = {
  [requestSummaryPreviewSections.instantRefundBankTransfer]: {
    titleKey: titleKeys.instantRefund,
    methodNameKey: methodNameKeys.bankTransfer,
    instant: true,
    Icon: BankIcon,
  },
  [requestSummaryPreviewSections.instantRefundOpm]: {
    titleKey: titleKeys.instantRefund,
    methodNameKey: methodNameKeys.originalPaymentMethod,
    instant: true,
    Icon: CreditCardIcon,
  },
  [requestSummaryPreviewSections.instantRefundGiftCard]: {
    titleKey: titleKeys.instantRefund,
    methodNameKey: methodNameKeys.giftCard,
    instant: true,
    Icon: GiftIcon,
  },
  [requestSummaryPreviewSections.instantRefundStoreCredit]: {
    titleKey: titleKeys.instantRefund,
    methodNameKey: methodNameKeys.storeCredit,
    instant: true,
    Icon: StorefrontIcon,
  },
  [requestSummaryPreviewSections.refundOpm]: {
    titleKey: titleKeys.refund,
    methodNameKey: methodNameKeys.originalPaymentMethod,
    instant: false,
    Icon: CreditCardIcon,
  },
  [requestSummaryPreviewSections.refundGiftCard]: {
    titleKey: titleKeys.refund,
    methodNameKey: methodNameKeys.giftCard,
    instant: false,
    Icon: GiftIcon,
  },
  [requestSummaryPreviewSections.refundStoreCredit]: {
    titleKey: titleKeys.refund,
    methodNameKey: methodNameKeys.storeCredit,
    instant: false,
    Icon: StorefrontIcon,
  },
  [requestSummaryPreviewSections.instantExchange]: {
    titleKey: titleKeys.instantExchange,
    methodNameKey: null,
    instant: true,
    Icon: ArrowsClockwiseIcon,
  },
  [requestSummaryPreviewSections.exchange]: {
    titleKey: titleKeys.exchange,
    methodNameKey: null,
    instant: false,
    Icon: ArrowsClockwiseIcon,
  },
}
